import { FC } from 'react'
import { useLang } from './Metronici18n'
import { IntlProvider } from 'react-intl'
import '@formatjs/intl-relativetimeformat/polyfill'
import '@formatjs/intl-relativetimeformat/locale-data/en-CH'
import '@formatjs/intl-relativetimeformat/locale-data/de-CH'
import '@formatjs/intl-relativetimeformat/locale-data/fr-CH'
import '@formatjs/intl-relativetimeformat/locale-data/it-CH'

import deMessages from './messages/de.json'
import enMessages from './messages/en.json'
import frMessages from './messages/fr.json'
import itMessages from './messages/it.json'
import { WithChildren } from '../helpers'

const allMessages = {
  de: deMessages,
  en: enMessages,
  fr: frMessages,
  it: itMessages,
}

const I18nProvider: FC<WithChildren> = ({ children }) => {
  const locale = useLang()
  const messages = allMessages[locale]

  return (
    <IntlProvider locale={locale} messages={messages}>
      {children}
    </IntlProvider>
  )
}

export { I18nProvider }
